import React from 'react';
import AppRoutes from './routes/AppRoutes';
import { useAuth } from 'react-oidc-context';
import './App.css';
import { Box, CircularProgress } from '@mui/material';
import { useLocation } from 'react-router-dom';

function App() {
  const auth = useAuth();
  const location = useLocation();
  const isLogoutPage = location.pathname === '/logout';

  if (auth.isLoading && !isLogoutPage) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  if (auth.error && !isLogoutPage) return <div>Auth error: {auth.error.message}</div>;

  if (!auth.isAuthenticated && !isLogoutPage) {
    auth.signinRedirect();
    return <div>Redirecting to Login...</div>;
  }

  return <AppRoutes />;
}

export default App;
